import React from "react";
import { GlobalProvider } from "./context/GlobalContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./component/Layout";
import Layout2 from "./component/Layout2";
import Home from "./component/Home";
import Job from "./component/Job";
import Login from "./component/Login";
import Register from "./component/Register";
import Dashboard from "./component/Dashboard";
import Dashboard2 from "./component/Dashboard2";
import Dashboard3 from "./component/Dashboard3";
import Dashboard4 from "./component/Dashboard4";
import Dashboard5 from "./component/Dashboard5";
import JobDetail from "./component/JobDetail";
import NotFound from "./component/404NotFound";
import OnlyAdmin from "./component/OnlyAdmin";

import { Navigate } from "react-router-dom";

import Cookies from "js-cookie";

function App() {
  const LoginRoute = (props) => {
    if (Cookies.get("token") === undefined) {
      return <Navigate to={"/onlyAdmin"} />;
    } else if (Cookies.get("token") !== undefined) {
      return props.children;
    }
  };

  const LoginRoute2 = (props) => {
    if (Cookies.get("token") !== undefined) {
      return <Navigate to={"/"} />;
    } else if (Cookies.get("token") === undefined) {
      return props.children;
    }
  };

  return (
    <BrowserRouter>
      <GlobalProvider>
        <Routes>
          <Route
            path="*"
            element={
              <Layout>
                <NotFound />
              </Layout>
            }
          />

          <Route
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />

          <Route
            path="/login"
            element={
              <Layout>
                <LoginRoute2>
                  <Login />
                </LoginRoute2>
              </Layout>
            }
          />

          <Route
            path="/register"
            element={
              <Layout>
                <Register />
              </Layout>
            }
          />
          <Route
            path="/job-vacancy"
            element={
              <Layout>
                <Job />
              </Layout>
            }
          />
          <Route
            path="/dashboard/list-job-vacancy/edit/:idData"
            element={
              <Layout2>
                <Dashboard3 />
              </Layout2>
            }
          />

          <Route
            path="/onlyAdmin"
            element={
              <Layout>
                <OnlyAdmin />
              </Layout>
            }
          />

          <Route
            path="/dashboard"
            element={
              <Layout2>
                <LoginRoute>
                  <Dashboard />
                </LoginRoute>
              </Layout2>
            }
          />

          <Route
            path="/dashboard/list-job-vacancy"
            element={
              <Layout2>
                <Dashboard2 />
              </Layout2>
            }
          />

          <Route
            path="/dashboard/list-job-vacancy"
            element={
              <Layout2>
                <Dashboard2 />
              </Layout2>
            }
          />
          <Route
            path="/dashboard/list-job-vacancy/form"
            element={
              <Layout2>
                <Dashboard3 />
              </Layout2>
            }
          />

          <Route
            path="/dashboard/reset-password"
            element={
              <Layout2>
                <Dashboard5 />
              </Layout2>
            }
          />

          <Route
            path="/dashboard/profile"
            element={
              <Layout2>
                <Dashboard4 />
              </Layout2>
            }
          />

          <Route
            path="/job-vacancy/:idData"
            element={
              <Layout>
                <JobDetail />
              </Layout>
            }
          />
        </Routes>
      </GlobalProvider>
    </BrowserRouter>
  );
}

export default App;
